<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { rules } from '@/utils/validators'

import UploadImage from '@/components/UploadImage'
import GoogleAddressAutocomplete from '@/components/GoogleAddressAutocomplete'
import googleMapsApi from '@/mixins/googleMapsApi'

export default {
  name: 'OnboardingProfileSetup',
  components: { GoogleAddressAutocomplete },
  mixins: [validationMixin, googleMapsApi],
  props: {
    user: { type: Object, required: true },
    submitting: { type: Boolean, default: () => false }
  },
  data() {
    return {
      rules,
      form: {
        sellerLocation: {
          name: '',
          place_id: '',
          latitude: null,
          longitude: null
        },
        pickupInstructions: ''
      }
    }
  },
  created() {
    // Event tracking
    const { once } = this.lodash
    const { logEvent } = this.$amplitude

    const addressAdded = once(() => {
      const props = { sellerLocation: this.form.sellerLocation }
      logEvent('Seller Onboarding: Address Added', props)
    })
    this.addressAdded = () => {
      if (this.form.sellerLocation.name) addressAdded()
    }

    const instructionsAdded = once(() => {
      const props = { pickupInstructions: this.form.pickupInstructions }
      logEvent('Seller Onboarding: Pickup instructions Added', props)
    })
    this.instructionsAdded = () => {
      if (this.form.pickupInstructions) instructionsAdded()
    }

    // Prefill form
    const { sellerLocation, pickupInstructions } = this.user
    this.form = {
      sellerLocation: sellerLocation || {},
      pickupInstructions
    }
  },
  mounted() {
    // GoogleAddressAutocomplete uses Google Maps Places API to get geo suggests for autocompletion
    this.importMapsApi()
  },
  methods: {
    submit() {
      if (this.submitting || this.$v.$invalid) return

      const {
        sellerLocation: { __typename, ...sellerLocation },
        pickupInstructions
      } = this.form

      const data = { sellerLocation, pickupInstructions }
      this.$emit('submit', data)
    }
  },
  validations: {
    form: {
      sellerLocation: {
        name: { required },
        place_id: { required }
      }
    }
  }
}
</script>

<template>
  <div class="view-grid">
    <div>
      <!-- Onboarding Profile // Address -->
      <form @submit.prevent="submit()">
        <!-- Title -->
        <div class="display-1 font-weight-bold accent--text">
          Fill in your details
        </div>

        <!-- Location -->
        <div class="my-3">
          <div class="font-weight-bold">
            What's your address?
          </div>
          <div class="body-2">
            This is where we'll pick up the food for delivery.
          </div>
          <div v-if="mapsApiLoaded">
            <GoogleAddressAutocomplete
              v-model="form.sellerLocation"
              label="Please type your address"
              required
              @blur="addressAdded"
            />
          </div>
        </div>

        <!-- Pickup instructions -->
        <div class="my-3">
          <div class="font-weight-bold">
            Special instructions
          </div>
          <div class="body-2">
            Pickup location, gate number, etc.
          </div>
          <v-text-field
            v-model.trim="form.pickupInstructions"
            class="secondary--text"
            label="Pickup instructions"
            @blur="instructionsAdded"
          />
        </div>

        <!-- Action Buttons -->
        <div class="my-5">
          <v-btn
            :loading="submitting"
            :disabled="$v.$invalid"
            type="submit"
            rounded
            depressed
            color="primary"
          >
            Continue
          </v-btn>
        </div>
      </form>
    </div>
  </div>
</template>
